// --- 统计分析 --- //

export default [
  {
    name: 'AnalysisOfBaseProductivity',
    path: '/supplySystem/:supplyId/AnalysisOfBaseProductivity',
    meta: { title: '基地生产力综合分析' },
    component: require('business/supplySystem/statisticalAnalysis/AnalysisOfBaseProductivity/list.vue').default
  },
  {
    name: 'AnalysisOfBaseProductivity',
    path: '/supplySystem/:supplyId/base/:baseId/AnalysisOfBaseProductivity',
    meta: { title: '基地生产力分析' },
    component: require('business/supplySystem/statisticalAnalysis/AnalysisOfBaseProductivity/list.vue').default
  },
  {
    name: 'baseProductivityStatistics',
    path: '/supplySystem/:supplyId/baseProductivityStatistics',
    meta: { title: '基地生产力综合统计' },
    component: require('business/supplySystem/statisticalAnalysis/baseProductivityStatistics/list.vue').default
  },
  {
    name: 'baseProductivityStatistics',
    path: '/supplySystem/:supplyId/base/:baseId/baseProductivityStatistics',
    meta: { title: '基地生产力统计' },
    component: require('business/supplySystem/statisticalAnalysis/baseProductivityStatistics/list.vue').default
  }
]
